import { useState, useEffect } from 'react';

export const useMatchMedia = (query: string): boolean => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query);
    setMatches(mediaQueryList.matches);

    const handleChange = (event: MediaQueryListEvent) =>
      setMatches(event.matches);

    // addEventListener on MediaQueryList is supported from Safari 14+.
    // Safari 12.1 / iOS 12.2 (in browserslist) only have the legacy addListener API.
    if (mediaQueryList.addEventListener) {
      mediaQueryList.addEventListener('change', handleChange);
      return () => mediaQueryList.removeEventListener('change', handleChange);
    }
    mediaQueryList.addListener(handleChange);
    return () => mediaQueryList.removeListener(handleChange);
  }, [query]);

  return matches;
};
